export default __webpack_public_path__ + "static/media/cuci-tangan.57025923.png";